import { ModicaInput } from "@modica-library/input/react";

type Props = {
  label?: string;
  value?: string;
  onChange?: (e: any) => void;
  error?: string;
  assistiveText?: string;
  placeholder?: string;
  type?: string;
  inputMode?: string;
  autoComplete?: string;
  maxLength?: number;
  className?: string;
};

/** Thin wrapper over @modica-library/input, preserving our (label/value/error string) API. */
export function Input({ label, value, onChange, error, assistiveText, placeholder, type = "text", inputMode, autoComplete, className }: Props) {
  return (
    <ModicaInput
      label={label ?? ""}
      value={value ?? ""}
      onChange={onChange}
      error={!!error}
      errorMessage={error}
      assistiveText={assistiveText}
      placeholder={placeholder}
      type={type}
      inputmode={inputMode}
      autocomplete={autoComplete}
      class={className}
    />
  );
}
